<template>
  <div>
    <div
      class="
        ts-shadow
        ts-px-2
        ts-py-2
        ts-flex
        ts-justify-between
        ts-items-center
        ts-rounded
      "
    >
      <h6 class="ts-uppercase ts-mb-0">
        {{ $t('purchaseOrder.productList') }}
      </h6>
      <div class="ts-relative" style="width: 300px">
        <input
          v-model.trim="search"
          type="text"
          class="
            ts-w-full
            ts-border
            ts-float-right
            ts-px-2
            ts-py-1
            ts-rounded
            ts-outline-none
            ts-pr-6
          "
          :placeholder="$t('purchaseOrder.searchProductList')"
        />
        <span
          class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2"
          style="margin-top: 7px"
          ><i class="fa fa-search"></i
        ></span>
      </div>
    </div>
    <div
      class="
        ts-p-3
        ts-shadow-outline
        ts-rounded
        ts-mt-3
        ts-h-full
        ts-overflow-scroll
        ts-py-3
      "
    >
      <table class="ts-w-full">
        <tr
          class="ts-border-b"
          v-for="(product, index) in getProduct({
            chosenProduct: model.po_detail,
            search: search,
          })"
          :key="index"
        >
          <td>{{ product.pro_group_name_en }}</td>
          <td>{{ product.category_name_en }}</td>
          <td>{{ product.barcode }}</td>
          <td>{{ product.product_name_en }}</td>
          <td style="width: 5%">
            <input
              type="number"
              v-model.number="product.qty"
              class="ts-px-3 ts-py-1 ts-outline-none"
              placeholder="QTY"
              @keypress.enter="addItem(product)"
            />
          </td>
          <td class="ts-px-4">
            {{ getCostPrice({ product_id:product.product_id, uom_id:product.uom_id }) }}
          </td>
          <td style="width: 1%" class="text-center">
            <a href="#" v-tooltip="$t('add')" @click.prevent="addItem(product)">
              <i class="fa fa-plus"></i>
            </a>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'productList',
  props: ['value'],
  data() {
    return {
      search: '',
      model: {},
    }
  },
  computed: {
    ...mapGetters('purchaseOrder/order', ['getProduct', 'getCostPrice']),
  },
  created() {
    this.model = this.value
  },
  methods: {
    addItem(product) {
			let cost = product.sale_code[0].product_price ?  product.sale_code[0].product_price.cost : 0
			let grandTotal =  _.round(cost * (product.qty ? product.qty : 1), 4)

      this.model.po_detail.push({
        product_id: product.product_id,
        uom_id: product.uom_id,
        uom_cat_id: product.uom_cat_id,
        qty: product.qty ? product.qty : 1,
        maximum_reorder_allow: product.maximum_reorder_allow,
        alloworder: false,
        cost: cost,
        discount_rate: 0,
        cost_in_bath: cost * this.model.fx_rate_thb,
        discount_type: '%',
        total_after_discount: grandTotal,
        total_after_discount_in_bath: grandTotal * this.model.fx_rate_thb
      })
    },
  },
}
</script>